export default __webpack_public_path__ + "static/media/10.736299a8.webp";